export const FILE_UPLOAD_HISTORY_CONSTANT = {
  // 対象テーブル
  TARGET_TABLE: 'batchupload_job_batchupload_job_log',
};
